<template>
  <div class="diadin">
    <div class="title">
      <div class="title_1">{{ $t('menu.Basicinformation') }}</div>
      <!-- <div v-if="type">
        <el-button type="primary">提交</el-button>
        <el-button @click="goBack">取消</el-button>
      </div> -->
      <!-- <div>
        <el-button @click="handleEdit">返回</el-button>
      </div> -->
    </div>
    <div class="cont">
      <div class="contbox">
        <div class="conttitle">{{ $t('menu.OrderNo') }}</div>
        <div>{{ mation[0].po.orderNumber }}</div>
      </div>
      <!-- <div class="contbox">
        <div class="conttitle">{{ $t('menu.ContractNumber') }}</div>
        <div>{{ mation[0].po.saleNumber }}</div>
      </div> -->

      <div class="contbox">
        <div class="conttitle">{{ $t('menu.State') }}</div>
        <div>{{ formatStatus(mation[0].po.status) }} </div>
      </div>

      <!-- <div class="contbox">
        <div class="conttitle">{{ $t('menu.Distributor') }}</div>
        <div>{{ mation[0].po.dealerName }}</div>
      </div> -->


      <div class="contbox">
        <div class="conttitle">{{ $t('menu.OrderAmount') }}</div>
        <div>{{ mation[0].po.orderAmount }}</div>
      </div>

      <div class="contbox">
        <div class="conttitle">{{ $t('menu.Paymentmethod') }}</div>
        <!-- <div>{{ jstype(mation[0].po.paymentMethod) }}</div> -->
        <div>
          <el-select disabled v-model="mation[0].po.paymentMethod" placeholder="请选择">
            <el-option v-if="inle == 'zh'" v-for="item in jsfs" :key="item.dictValue" :label="item.dictLabel"
              :value="item.dictValue">
            </el-option>
            <el-option v-if="inle !== 'zh'" v-for="item in jsfs" :key="item.dictValue" :label="item.dictLabelEn"
              :value="item.dictValue">
            </el-option>
          </el-select>
        </div>
      </div>

      <div class="contbox">
        <div class="conttitle">{{ $t('menu.Currency') }}</div>
        <div>{{ mation[0].po.currencyType }}</div>
      </div>

      <!-- <div class="contbox">
        <div class="conttitle">{{ $t('menu.Country') }}</div>
        <div>{{ formatCKBG(mation[0].po.address) }}</div>
      </div> -->

      <!-- <div class="contbox">
        <div class="conttitle">结算方式</div>
        <div>
          <el-select v-model="ruleForm.region" placeholder="请选择">
            <el-option label="线下转账" value="线下转账"></el-option>
            <el-option label="账户支付" value="账户支付"></el-option>
          </el-select>
        </div>
      </div> -->
      <!-- <div class="contbox">
        <div class="conttitle">价格条款</div>
        <div>
          <el-select v-model="mation[0].po.priceTerms" placeholder="请选择">
            <el-option label="FOB" value="FOB"></el-option>
          </el-select>
        </div>
      </div> -->
      <div class="contbox">
        <div class="conttitle">{{ $t('menu.FreightMode') }}</div>
        <div>
          <el-select v-model="mation[0].po.shippingMethod" placeholder="请选择">
            <el-option v-if="inle == 'zh'" v-for="item in hyList" :key="item.dictValue" :label="item.dictLabel"
              :value="item.dictValue">
            </el-option>
            <el-option v-if="inle !== 'zh'" v-for="item in hyList" :key="item.dictValue" :label="item.dictLabelEn"
              :value="item.dictValue">
            </el-option>
          </el-select>
        </div>
      </div>

      <div class="contbox">
        <div class="conttitle">{{ $t('menu.ExpectedShippingdate') }}</div>
        <!-- <div>{{ formatTime(mation[0].po.shippingDate) }}</div> -->
        <div class="pay-type">
          <el-date-picker style="width: 100%;" v-model="mation[0].po.shippingDate" type="date" placeholder="选择日期"
            format="yyyy-MM-dd" value-format="yyyy-MM-dd">
          </el-date-picker>
        </div>
      </div>


      <div class="contbox" style="width: 85%;">
        <div class="conttitle">{{ $t('menu.Remarks') }}</div>
        <div style="width: 40%;">
          <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入内容"
            v-model="mation[0].po.userRemarks">
          </el-input>
        </div>
      </div>
    </div>
    <div class="title" style="margin-bottom: 20px; justify-content: left">
      <div class="title_1">
        {{ $t('menu.ProductDetails') }}
      </div>
    </div>
    <div class="add" @click="openAddPop" v-if="mation[0].po.paymentMethod == 'cash'">{{ $t('menu.AddTo') }}</div>


    <div>
      <el-table  empty-text=" " :data="mation[0].poParts" style="width: 100%" stripe border highlight-current-row
        :cell-style="cellStyle">
        <el-table-column prop="partNumber" :label="$t('menu.PartCode')" width="180"></el-table-column>
        <el-table-column prop="partName" :label="$t('menu.PartName')" width="180">
          <template slot-scope="scope">
            <div>{{ inle == 'zh' ? scope.row.partName : scope.row.partNameEn }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="motorName" :label="$t('menu.VehicleModel')">
          <template slot-scope="scope">
            <div>{{ sxcx(scope.row.motorId)  }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="currencyType" :label="$t('menu.Currency')">
          <template slot-scope="scope">
            <div>{{ mation[0].po.currencyType }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="unitPrice" :label="$t('menu.UnitPrice')" width="130"></el-table-column>
        <el-table-column prop="quantity" :label="$t('menu.Quantity')" width="150"
          v-if="mation[0].po.paymentMethod == 'cash'">
          <template slot-scope="scope">
            <div style="width: 100%; display: flex; justify-content: center;">
              <el-input-number v-model="scope.row.quantity" :min="1"
                @change="changeNum($event, scope.row)"></el-input-number>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="amount" :label="$t('menu.SubTotal')" width="150"></el-table-column>
        <el-table-column width="150" v-if="mation[0].po.paymentMethod == 'cash'">
          <template slot="header" slot-scope="scope">
            <div>{{ $t('menu.Operation') }}</div>
          </template>
          <template slot-scope="scope">
            <div style="color: #409eff;cursor: pointer;" @click="delMX(scope.row, scope.$index)">{{ $t('menu.Delete') }}
            </div>
          </template>
        </el-table-column>
      </el-table>

      <div class="price-box">{{ $t('menu.OrderAmount') }} <p>{{ priceTotal }} {{ mation[0].po.currencyType }}</p>
      </div>
    </div>

    <div class="btn-box">
      <div class="btn blue" v-if="pageType == 'edit'" @click="updateOrder(1)">{{ $t('menu.Confirm') }}</div>
      <div class="btn blue" v-else @click="updateOrder(0)">{{ $t('menu.Confirm') }}</div>
      <div class="btn" @click="goBack">{{ $t('menu.Cancel') }}</div>
    </div>



    <el-dialog :title="$t('menu.AddParts')" :visible.sync="addPop" width="50%">
      <div class="dialog-box" style="height: 500px;">
        <div style="display: flex;align-items: center;margin-bottom: 10px;">
          <!-- <el-select v-model="value" placeholder="车类" style="width: 10%;margin-right: 20px;">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select> -->
          <el-select class="el-select1" v-model="formInline.category" :placeholder="$t('menu.VehicleModel')"
            style="width: 10%;margin-right: 20px;">
            <el-option v-for="item in cxList" :key="item.id" :label="item.seriesModel" :value="item.id"
              v-if="item.id !== 9000 && inle == 'zh'">
            </el-option>
            <el-option v-for="item in cxList" :key="item.id" :label="item.seriesModelEn" :value="item.id"
              v-if="item.id !== 9000 && inle !== 'zh'">
            </el-option>
          </el-select>
          <!-- <el-select v-model="value" placeholder="年份" style="width: 10%;margin-right: 20px;">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select> -->
          <el-input :placeholder="`车型名称/${$t('menu.Code')}/${$t('menu.FrameNumber')}/${$t('menu.PartCode')}`"
            v-model="formInline.title" style="width: 20%;margin-right: 20px;"></el-input>

          <el-button type="primary" @click="onSubmit">{{ $t('menu.search') }}</el-button>
        </div>

        <el-table :data="mation1" ref="multipleTable" style="width: 100%" :cell-style="cellStyle" border
          @selection-change="handleSelectionChange" @row-click="clickRow">
          <el-table-column type="selection" width="55">
          </el-table-column>
          <el-table-column prop="partCode" :label="$t('menu.PartCode')" width="180">
          </el-table-column>
          <el-table-column prop="partName" :label="$t('menu.PartName')" width="180">
            <template slot-scope="scope">
              <div>{{ inle == 'zh' ? scope.row.partName : scope.row.partName2 }}</div>
            </template>
          </el-table-column>
        
          <el-table-column prop="salePrice" :label="$t('menu.UnitPrice')">
           
          </el-table-column>
         
          <!-- <el-table-column prop="status" label="状态">
          </el-table-column> -->
        </el-table>

      </div>
      <span slot="footer" class="dialog-footer">
        <div class="popbtn">
          <el-button type="primary" @click="confirm">{{ $t('menu.Confirm') }}</el-button>
        </div>

      </span>
    </el-dialog>

  </div>
</template>

<script>
import { orderSearch, querytype, myPoUpdate, listMcSeriesModels, partRetailerOfDealer, myPoReApply } from "../../api/api";

export default {
  data () {
    return {
      addPop: false,
      type: 1,
      mation: [],
      ruleForm: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: "",
      },
      orderNumber: '',
      type: false,
      prList: [],
      hyList: [],
      jsfs: [],
      ckgb: [],
      cxList: [],
      formInline: {
        title: "",
        status: "",
        startTime: "",
        endTime: "",
        contact: "",
        category: "",
        type: "",
      },
      mation1: [],
      page: 1,
      selectList: [],
      inle: 'zh',
      pageType: '',
    };
  },
  created () {
    this.pageType = sessionStorage.getItem('pageType')
    let a = sessionStorage.getItem('i18n')
    this.inle = a
    this.type = this.$route.query.type;
    this.orderNumber = this.$route.query.orderNumber
    this.biao();
    this.querytyp()
    this.jg()
    this.listMcSeriesModel();

  },
  computed: {
    priceTotal () {
      let num = 0
      this.mation[0].poParts.forEach(i => {
        num += i.amount
      })
      return num.toFixed(2)
    }
  },
  methods: {
    clickRow (row) {
      const selectData = this.$refs.multipleTable.selection
      if (selectData.length > 0) {
        selectData.forEach(item => {
          // 判断 如果当前的一行被勾选, 再次点击的时候就会取消选中
          if (item == row) {
            this.$refs.multipleTable.toggleRowSelection(row, false);
          } else {
            // 不然就让当前的一行勾选
            this.$refs.multipleTable.toggleRowSelection(row, true);
          }
        })
      }
      else {
        this.$refs.multipleTable.toggleRowSelection(row, true);
      }
    },
    formatPrice (row) {
      if (this.mation[0].po.currencyType == 'CNY') {
        return row.purchasePriceCny
      } else if (this.mation[0].po.currencyType == 'USD') {
        return row.purchasePriceUsd
      } else {
        return row.purchasePriceEur
      }
    },
    async onSubmit () {
      //配件查询




     
      let param = new URLSearchParams();
      let mcSeriesModelId = this.formInline.category;
      let searchKey = this.formInline.title;
     



      const { data: res } = await partRetailerOfDealer(
        param,
        1,
        100,
        mcSeriesModelId,
        searchKey,
        '',
        1
      );
      this.mation1 = res.rows
      // res.data.list.forEach((e, i) => {
      //   this.mation1[i].buyNum = e.minPurchaseQuantity
      // });
      this.totale = res.total;
      // if (res.data.total > 0) {
      //   this.pcc = false
      // } else {
      //   this.pcc = true
      // }
    },
    sxcx(e){
      let a =''
      this.cxList.forEach(z=>{
        if(z.id==e){
          if(this.inle == 'zh'){
            a=z.seriesModel
          }else{
            a=z.seriesModelEn
          }

        }
      })
      return a
    },
    //获取车型
    async listMcSeriesModel () {
      let param = new URLSearchParams();

      const { data: res } = await listMcSeriesModels(param);

      this.cxList = res.data;
      this.formInline.category = this.mcSeriesModelId
      // this.seriesModel = this.list[0].seriesModel;
    },
    //mation[0].poParts
    handleSelectionChange (e) {
      console.log('eee', e)
      this.selectList = e
    },
    delMX (row, index) {
      row.deleted = true
      let data = this.mation[0]
      if (data.po.shippingDate) {
        if (data.po.shippingDate.length == 10) {
          data.po.shippingDate = data.po.shippingDate + 'T00:00:00'
        }
      }
      myPoUpdate(data).then(r => {
        if (r.data.code == 200) {
          this.biao();
        } else {
          this.$message.error(r.data.message)
          return
        }
      })
    },
    updateOrder (num) {
      if (num == 0) {//TODO 重新提交
        // myPoReApply(this.mation[0]).then(r => {
        //   console.log(r)
        // })

      } else {//修改

        let data = this.mation[0]
        if (data.po.shippingDate) {
          if (data.po.shippingDate.length == 10) {
            data.po.shippingDate = data.po.shippingDate + ' 00:00:00'
          }
        }

        myPoUpdate(data).then(r => {
          if (r.data.code == 200) {
            this.$message.success('提交成功')
            // location.reload()
            this.biao();
            setTimeout(() => {
              this.$router.back()
            }, 500);

          } else {
            this.$message.error(r.data.message)
            return
          }
        })

      }

    },
    jg () {
      let param = new URLSearchParams();
      querytype(param, 't_po_price_item').then(r => {
        if (r.data.code == 200) {
          this.prList = r.data.data
        }
      })
      querytype(param, 't_po_shipment_method').then(r => {
        if (r.data.code == 200) {
          this.hyList = r.data.data
        }
      })
      querytype(param, 'sys_dealer_area').then(r => {
        if (r.data.code == 200) {
          console.log(123, r)
          this.ckgb = r.data.data
        }
      })
    },
    formatCKBG (val) {
      let str = ''
      this.ckgb.forEach(item => {
        if (item.dictValue == val) {
          str = item.dictLabel
        }
      })
      return str
    },
    formatTime (time) {
      if (time) {
        let str = time.replace('T', ' ')
        return str.slice(0, 10)
      } else {
        if (this.inle == 'zh') {
          a = '暂无数据'
        } else {
          a = 'No data available yet'
        }
        return a
      }

    },
    async querytyp () {
      let param = new URLSearchParams();
      const { data: res } = await querytype(
        param,
        't_po_payment_method'
      );
      this.jsfs = res.data;
    },
    jstype (e) {
      let c = ''
      let a = this.jsfs
      a.forEach(z => {
        if (e == z.dictValue) {
          c = z.dictLabel
        }
      })
      return c
    },
    formatStatus (status) {
      if (status == -2) {
        return this.$t('menu.Rejected')
      } else if (status == -1) {
        return this.$t('menu.Cancelled')
      } else if (status == 0) {
        return '待支付'
      } else if (status == 1) {
        return this.$t('menu.PendingReview')
      } else if (status == 2) {
        return '已发货'
      } else if (status == 3) {
        return this.$t('menu.UnderDelivery')
      } else if (status == 4) {
        return this.$t('menu.Completed')
      }
    },
    confirm () {
      let arr = []
      console.log(this.selectList);
      
      this.selectList.forEach(item => {
        let obj = {...item}
        // obj.createdById = item.createdById
        obj.createdTime = item.createdTime
        obj.deleted = false
        obj.discountUnitPrice = 0
        // obj.partId = item.id
        obj.itemNum = 1
        obj.motorColor = null
        obj.id=null
        obj.motorId = item.mcSeriesModelId
       obj.unitPrice=item.salePrice
        obj.partName = item.partName
        obj.partNameEn = item.partName2
        obj.partNumber = item.partCode
        obj.partNumberErp = null
        obj.planNum = null
        obj.poId = null
        obj.quantity = 1
        // if (this.mation[0].po.currencyType == 'CNY') {
        //   obj.unitPrice = item.purchasePriceCny
        // } else if (this.mation[0].po.currencyType == 'USD') {
        //   obj.unitPrice = item.purchasePriceUsd
        // } else {
        //   obj.unitPrice = item.purchasePriceEur
        // }
        obj.amount = obj.quantity * obj.unitPrice
        arr.push(obj)
      })
      this.mation[0].poParts.push(...arr)
      this.addPop = false
      this.selectList = []
    },
    openAddPop () {
      this.addPop = true
    },
    changeNum (e, row) {
      row.amount = (e * Number(row.unitPrice)).toFixed(2)
    },
    cellStyle ({ row, column }) {
      return "height:50px;text-align:center;"
    },
    async biao () {
      let param = new URLSearchParams();
      let orderNumber = this.orderNumber
      const { data: res } = await orderSearch(param, orderNumber);

      this.mation = []
      this.mation.push(res.data)
      console.log(111111111, res, this.mation)
      this.totale = res.data.total;
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert("submit!");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleEdit (index, row) {
      this.$router.push({
        path: "/sell",
        query: {},
      });
    },
    goBack () {
      this.$router.back()
    }
  },
};
</script>

<style lang="less" scoped>
.diadin {
  width: 100%;
  min-height: 80vh;
  background-color: #fff;
  padding: 20px;
  padding-left: 0;
}

.title {
  width: 100%;
  border-bottom: 1px solid #f2f2f2;
  padding: 20px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.title_1 {
  padding-left: 15px;
  border-left: 5px solid #409eff;
}

.cont {
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 30px;
}

.contbox {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 30%;
  margin-top: 30px;
}

.contbox1 {
  display: flex;
  align-items: center;
  width: 30%;
}

.conttitle {
  width: 180px;
  text-align: left;
  margin-bottom: 10px;
  color: #909399;
}

/deep/.el-form-item__content {
  width: 100%;
}

/deep/.el-select {
  width: 95%;
}

/deep/.el-table th.is-leaf {
  text-align: center;
  background-color: #d7d7d7;
}

.actio {
  color: #409eff;
}

.product-box {
  margin-top: 20px;
  display: flex;

  div {
    margin-right: 20px;
  }

  .daochu {
    color: #409eff;
  }
}

.btn-box {
  margin-top: 80px;
  display: flex;

  div {
    margin-right: 20px;
  }

  .blue {
    border: 0 !important;
    background-color: #409eff;
    color: #fff !important;
  }

  .btn {
    cursor: pointer;
    border: 1px solid #eee;
    width: 100px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
  }

}

.popbtn {
  width: 200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.add {
  cursor: pointer;
  border: 1px solid #409eff;
  width: 100px;
  height: 40px;
  color: #409eff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
}

/deep/ .el-input-number {
  transform: scale(0.7);
}

.price-box {
  margin-top: 20px;
  display: flex;
  align-items: center;

  p {
    margin-left: 10px;
    color: red;
  }
}

.search {
  margin-left: 20px;
  width: 150px;
  height: 40px;
  border: 1px solid #409eff;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #409eff;
}

.dialog-box {
  overflow-y: auto;
  height: 400px;
}

.el-select1 {
  width: 15% !important;
}
</style>